import mergeWith from 'lodash/mergeWith';
import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import { defaultTheme } from './default.theme';
import { highContrastTheme } from './high-contrast.theme';

const mergeTheme = theme => {
  const mergedTheme = mergeWith({}, defaultTheme, theme, (targetValue, srcValue) => {
    // Concatenate arrays instead of overlapping. `undefined` means we leave to lodash to decide.
    return Array.isArray(srcValue) && Array.isArray(targetValue) ? srcValue.concat(targetValue) : undefined;
  });

  mergedTheme.kiosk = merge({}, defaultTheme.default, theme.default, defaultTheme.kiosk, theme.kiosk);
  mergedTheme.mobile = merge({}, defaultTheme.default, theme.default, defaultTheme.mobile, theme.mobile);

  mergedTheme.largeScreenKiosk = merge(
    {},
    defaultTheme.default,
    theme.default,
    defaultTheme.kiosk,
    theme.kiosk,
    defaultTheme.largeScreenKiosk,
    theme.largeScreenKiosk
  );

  mergedTheme.iPadKiosk = merge(
    {},
    defaultTheme.default,
    theme.default,
    defaultTheme.kiosk,
    theme.kiosk,
    theme.iPadKiosk
  );

  return mergedTheme;
};

export const getTheme = (tenantTheme, storeTheme, brandTheme, isHighContrast = false) => {
  const foundTheme = tenantTheme || {};
  const menuTheme = isEmpty(brandTheme) ? storeTheme : brandTheme;

  if (!isEmpty(menuTheme)) {
    const mergeTenantWithMenuTheme = merge({}, foundTheme, menuTheme, isHighContrast ? highContrastTheme : undefined);

    return mergeTheme(mergeTenantWithMenuTheme);
  }

  const mergedTheme = isHighContrast ? merge({}, foundTheme, highContrastTheme) : foundTheme;
  const mergedTenantTheme = mergeTheme(mergedTheme);

  return mergedTenantTheme;
};
